import React, { useState } from "react"
import { Download, Loader2 } from "lucide-react"
import { Button } from "../../../ui/button"

const ButtonGroup = (props) => {
  const {
    groupNames,
    submit,
    reset,
    type,
    spclButtons,
    idsearch,
    idreset,
    idspecial,
    freezButton
  } = props

  const [uploadButtonDisabled, setUploadButtonDisabled] = useState(false)

  const handleUploadClick = async (e) => {
    setUploadButtonDisabled(true)
    if (submit) {
      await submit(e)
    }
    setTimeout(() => {
      setUploadButtonDisabled(false)
    }, 3000)
  }

  return (
    <div className="">
      <div className="flex flex-wrap gap-2 items-center">
        {/* Primary Action Button (Search/Submit) */}
        <Button
          onClick={freezButton ? handleUploadClick : (submit ? (e) => submit(e) : null)}
          type={type || "button"}
          id={idsearch}
          disabled={freezButton && uploadButtonDisabled}
          variant="default"
        >
          {uploadButtonDisabled && freezButton && (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          )}
          {groupNames[0]}
        </Button>

        {/* Reset Button */}
        <Button
          onClick={() => reset()}
          type="reset"
          id={idreset}
          variant="outline"
        >
          {groupNames[1]}
        </Button>

        {/* Special Button (Download) */}
        {spclButtons && (
          <Button
            id={idspecial}
            className="bg-chart-warning hover:bg-chart-warning/90 text-gray-900 dark:text-gray-900"
            variant="secondary"
            asChild
            disabled={freezButton}
          >
            <a
              href={spclButtons[1].filePath}
              download={spclButtons[1].fileName}
              className="flex items-center justify-center"
            >
              <Download className="mr-2 h-4 w-4" />
              {spclButtons[0]}
            </a>
          </Button>
        )}
      </div>
    </div>
  )
}

export default ButtonGroup;